// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__22pXO","messages":"Chat_messages__qERKn","dateDivider":"Chat_dateDivider__3DbHn"};